/**
 * Site-wide SEO constants. Canonical URLs are always built against the production
 * origin — never window.location — so previews, www, and dev hosts can't publish a
 * canonical that points somewhere other than dealhawkpro.io.
 */
export const SITE_URL = "https://dealhawkpro.io";
export const SITE_NAME = "DealHawk";
/** 1200×630 PNG; SVG previews are ignored by Facebook, X, iMessage and Slack. */
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;

export function absoluteUrl(path: string): string {
  if (/^https?:\/\//i.test(path)) return path;
  return `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
}

export type JsonLd = Record<string, unknown>;

export function breadcrumbJsonLd(crumbs: { name: string; path?: string }[]): JsonLd {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: crumbs.map((c, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: c.name,
      ...(c.path ? { item: absoluteUrl(c.path) } : {}),
    })),
  };
}

export function faqJsonLd(faq: { q: string; a: string }[]): JsonLd {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faq.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
}
